/**
 *  Bổ sung mode export để truyền xuống dưới API export
 * DVMINH 29/03/2024
 **/
export default {
    Default: 0, // Xuất khẩu theo mặc định
    WithData: 1,    // Xuất khẩu với data đẩy xuống
    WithPayload: 2  // Xuất khẩu với dạng payload truyền xuống để lấy data bên dưới
};